import ChatBody from "components/Chat/ChatBody";
import ChatFooter from "components/Chat/ChatFooter";
import ChatHeader from "components/Chat/ChatHeader";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Container, Spinner, Button, Card, Row, Col } from "reactstrap";
import { Badge } from "reactstrap";
import { getSingleUser } from "store/actions/resolutionAction";
import { updateStatus } from "store/actions/resolutionAction";
import { resolutionChat } from "store/actions/resolutionAction";
import { getSingleResolution } from "store/actions/resolutionAction";

const ResolutionChat = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { singleResolution, resolutionchats, singleUser, isLoadings } =
    useSelector((state) => state.resolution);

  const handleButtonClick = async (item, status) => {
    await dispatch(updateStatus(id, status));
  };

  useEffect(() => {
    dispatch(getSingleResolution(id));
    dispatch(resolutionChat(id));
  }, []);

  return (
    <>
      <Container fluid className="my-6 my-md-8">
        <Card className="p-3 mb-4">
          <Row className="justify-content-center align-items-center">
            <Col xs={12} md={4} lg={6}>
              <h3 className="mb-0">Ticket Details</h3>
            </Col>
            <Col xs={12} md={8} lg={6} className="text-md-end mt-2 mt-md-0">
              <div className="d-flex flex-column flex-sm-row justify-content-md-end">
                {singleResolution?.status === "accepted" ? (
                  <Button
                    color="primary"
                    onClick={() =>
                      handleButtonClick(singleResolution, "Pending")
                    }
                    className="w-100 w-sm-50 w-lg-auto mb-2 mb-sm-0 mr-sm-2 btn btn-primary"
                  >
                    Reopen
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    onClick={() =>
                      handleButtonClick(singleResolution, "accepted")
                    }
                    className="w-100 w-sm-50 w-lg-auto mb-2 mb-sm-0 mr-sm-2 btn btn-primary"
                  >
                    Mark as Resolve
                  </Button>
                )}
                <Button
                  color="danger"
                  onClick={() =>
                    handleButtonClick(singleResolution, "rejected")
                  }
                  disabled={singleResolution?.status == "accepted"}
                  className="w-100 w-sm-50 w-lg-auto ml-0"
                >
                  Rejected
                </Button>
              </div>
            </Col>
          </Row>
        </Card>

        {isLoadings && (
          <div className="d-flex align-items-center justify-content-center spinner-container width-100% my-5">
            <Spinner color="primary" />
          </div>
        )}
        {!isLoadings && (
          <>
            <Card className="p-3 mb-4">
              <div className="d-flex flex-column flex-lg-row justify-content-between">
                <div className="mb-3 mb-lg-0 d-flex align-items-center justify-content-between justify-content-lg-start">
                  <h2 className="d-inline">Status:</h2>
                  {singleResolution?.status === "accepted" ? (
                    <h4 className="d-inline ml-2 mt-0">
                      <Badge color="success">{singleResolution?.status}</Badge>
                    </h4>
                  ) : (
                    <h4 className="d-inline ml-2 mt-0">
                      <Badge color="danger">{singleResolution?.status}</Badge>
                    </h4>
                  )}
                </div>

                <div className="mb-3 mb-lg-0 d-flex align-items-center justify-content-between justify-content-lg-start">
                  <h2 className="d-inline">Created:</h2>
                  <h4 className="d-inline ml-2">{singleResolution?.name}</h4>
                </div>

                {singleResolution?.athleteId && (
                  <div className="d-flex align-items-center justify-content-between justify-content-lg-start">
                    <h2 className="d-inline">Athlete ID:</h2>
                    <h4 className="d-inline ml-2">
                      {singleResolution?.athleteId}
                    </h4>
                  </div>
                )}
              </div>
            </Card>

            <ChatHeader />
            <ChatBody
              ticketChat={resolutionchats}
              singleuser={singleUser}
              singleResolution={singleResolution}
              id={id}
            />
            <ChatFooter />
          </>
        )}
      </Container>
    </>
  );
};

export default ResolutionChat;
